module.exports = __webpack_public_path__ + "img/ld_1@2x.c52cd63e.png";